export const states = [
  'N/A', 'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut',
  'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa',
  'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan',
  'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire',
  'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio',
  'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota',
  'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia',
  'Wisconsin', 'Wyoming',
];

export const stateOptions = states.map((state) => ({
  value: state,
  label: state,
}));

export const progressMessages = [
  ' Uploading file...',
  ' Analyzing content...',
  ' Extracting key legal terms...',
  ' Understanding context...',
  ' Identifying relevant statutes and regulations...',
  '️ Classifying concerns...',
  ' Cross-referencing legal precedents...',
  ' Summarizing findings...',
  ' Drafting report...',
  ' Reviewing for accuracy...',
  '️ Formatting and structuring report...',
  ' Finalizing report...',
];

export const concernColors = {
  'Extremely Concerning': 'darkred',
  'Very Concerning': 'red',
  'Moderately Concerning': 'orange',
  'Mildly Concerning': 'yellow',
  'No Concern': 'green',
};

export const POLL_INTERVAL_MS = 5000;
export const MESSAGE_ROTATION_MS = 4000;
// Give up polling after this long and surface a recoverable error. Generous vs.
// the typical 1-3 min analysis so we don't false-alarm a slow-but-working run.
export const POLL_TIMEOUT_MS = 360000; // 6 minutes
export const API_URL = import.meta.env.VITE_LAMBDA_URL;
